export default (str: string) =>
  str
    .toLowerCase()
    .trim()
    .replace(/[\W_]+/g, '-')
    .replace(/^\.-+|\.-+$/g, '');
